import $ from "jquery";

function applyFilters() {
    const categoryId = $('.tag[data-category-id].active').data('category-id');
    const tutorialOnly = $('input[data-tutorial]').is(':checked');

    $('[data-category-ids]').each(function() {
        const $element = $(this);
        const matchesCategory = !categoryId || $element.data('category-ids').toString().split(', ').includes(categoryId);
        const matchesTutorial = !tutorialOnly || $element.data('has-tutorial') === 1;
        $element.toggle(matchesCategory && matchesTutorial);
    });
}

$(document).on('click', '[data-category-id]', function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $(this).siblings('.tag[data-category-id]').removeClass('active');
        $(this).addClass('active');
    }
    applyFilters();
});

$(document).on('change', 'input[data-tutorial]', applyFilters);

$(applyFilters);
